import { render } from "./Tiger.vue?vue&type=template&id=1528f6c8&scoped=true"
import script from "./Tiger.vue?vue&type=script&lang=js"
export * from "./Tiger.vue?vue&type=script&lang=js"

import "./Tiger.vue?vue&type=style&index=0&id=1528f6c8&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1528f6c8"]])

export default __exports__